<script>
    export default {
        props: {
            value: {
                type: Object,
                default: null
            }
        },
        computed: {
            firstValidShare() {
                if (!this.value.valid_shares || this.value.valid_shares.length <= 0) {
                    return null;
                }

                return this.value.valid_shares[0] || null;
            }
        }
    }
</script>
<template>
    <div class="package-share-status">
        <template v-if="!firstValidShare">
            <span class="text-muted">{{ __('scoop-os.packages.share.not_shared') }}</span>
        </template>
        <template v-if="firstValidShare">
            <span class="label label-sucess">
                {{ __('scoop-os.packages.share.shared_for', {'periodStart': this.firstValidShare.validUntilReadable, 'periodEnd': this.firstValidShare.valid_till}) }}
            </span>
        </template>
    </div>
</template>